export enum MapContextMenuAction {
  MapTools = 'map-tools',
  CopyPosition = 'copy-position',
  PlaceSymbol = 'place-symbol',
}
